export default __webpack_public_path__ + "static/media/brainstorm.a0f6ace6.webp";